


export const baseURL = "https://admin.ratemyadmin.tech";
// export const baseURL = "http://localhost:3001";
export const apiEndpoints = {
    login: '/api/auth/login',
    signUp : '/api/auth/register',
    verifyOtp : '/api/auth/verify-otp',
}